import { render } from "./Knowledge.vue?vue&type=template&id=5b851006&scoped=true"
import script from "./Knowledge.vue?vue&type=script&lang=js"
export * from "./Knowledge.vue?vue&type=script&lang=js"

import "./Knowledge.vue?vue&type=style&index=0&id=5b851006&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b851006"]])

export default __exports__